import { lazyLoadView } from '@router/helpers';
export default [
  {
    path: '/i/:id(\\d+)/laporan-lingkup-pendidikan',
    name: 'laporan-lingkup-pendidikan',
    component: () => lazyLoadView(import('@views/instansi/laporan/lingkup/Index')),
    meta: {
      title: 'Monitoring Laporan Lingkup Satuan Pendidikan',
    },
  },
  {
    path: '/i/:id(\\d+)/laporan-lingkup-pendidikan/:psp_kp_pa_id',
    name: 'detail-laporan-lingkup-pendidikan',
    component: () => lazyLoadView(import('@views/instansi/laporan/lingkup/Detail')),
    meta: {
      title: 'Detail Laporan Lingkup Satuan Pendidikan',
    },
  },
  {
    path: '/i/:id(\\d+)/laporan-lokakarya-dinas',
    name: 'laporan-lokakarya-dinas',
    component: () => lazyLoadView(import('@views/instansi/laporan/lokakarya/Dinas')),
    meta: {
      title: 'Laporan Penjadwalan Kegiatan oleh BBGP / BGP',
    },
  },
  {
    path: '/i/:id(\\d+)/laporan-koordinator-pa',
    name: 'laporan-koordinator-pa',
    component: () => lazyLoadView(import('@views/instansi/laporan/koordinator/Fsp')),
    meta: {
      title: 'Laporan Kegiatan Koordinator Fasilitator',
    },
  },
  {
    path: '/i/:id(\\d+)/daftar-laporan-koordinator-pa',
    name: 'daftar-laporan-koordinator-pa',
    component: () => lazyLoadView(import('@views/instansi/laporan/koordinator/List')),
    meta: {
      title: 'Daftar Laporan Kegiatan Koordinator Fasilitator',
    },
  },
  {
    path: '/i/:id(\\d+)/detail-laporan-koordinator-pa/:akun_instansi_id',
    name: 'detail-laporan-koordinator-pa',
    component: () => lazyLoadView(import('@views/instansi/laporan/koordinator/Detail')),
    meta: {
      title: 'Detail Laporan Kegiatan Koordinator Fasilitator',
    },
  },
];
